/**
 * @file index.tsx
 * @author liuchen(loocliu@tencent.com)
 */
import { useCallback } from 'react';

import styles from './style/index.module.less';

interface IPlotProps {
  id: string;
  content: string;
  cardInfo: { name: string; url: string };
  onExpand: (id: string) => void;
}

const Plot = (props: IPlotProps) => {
  const { id, cardInfo, content, onExpand } = props;

  const handleTap = useCallback(() => {
    onExpand(id);
  }, [id, onExpand]);

  return (
    <>
      <div className={styles.root} onClick={handleTap}>
        <img className={styles.card} src={cardInfo.url} />
        <div className={styles.right}>
          <div className={styles['right-title']}>您收获新一段剧情!</div>
          <div className={styles['right-name']}>{cardInfo.name}</div>
          <div className={styles['right-text']}>
            “<div className={styles['right-text-inner']}>{content}</div>”
            <img
              className={styles.trigger}
              src="https://media-img.puui.qpic.cn/media_img/0/lena/PIC15v8wb_29_19/0"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default (Plot);
